module.exports = __webpack_public_path__ + "static/media/step4.6e0d3333.svg";